export default __webpack_public_path__ + "static/2-580cffce56299c3146c110fd5fc0b3fd.jpg";